import React from 'react';
import '../pageWelcome.css';
import AutoSizeTitle from '../../components/autoSizeTitle/AutoSizeTitle';
import { Typography } from 'antd';

const { Title, Text } = Typography;

const PageWelcome2Selfcare360 = ({ selectedEvaluation, pageNumber, orgName }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <div className='welcome-page-text'>
                        <Title level={5} style={{ color: '#339C98', marginTop: 12 }}>
                            ¿Qué hacer después de leer este informe?
                        </Title>
                        Te sugerimos usarlo como una guía práctica:
                        <br /><br />
                        1. <b>Reflexiona:</b> Revisa tus resultados con apertura.
                        <br />
                        Identifica tus fortalezas y las áreas donde puedes tener mayor impacto.
                        <br /><br />
                        2. <b>Prioriza:</b> Concéntrate primero en las 2 o 3 dimensiones con mayor riesgo.
                        <br />
                        Ahí es donde tus acciones generarán la mayor reducción de accidentalidad.
                        <br /><br />
                        3. <b>Actúa con rutinas concretas:</b> Más que grandes cambios, enfócate en hábitos diarios:
                        <br /><br />
                        4. <b>Haz seguimiento:</b> Usa los indicadores y metas sugeridas para medir tu avance.
                        <br />
                        La mejora sostenida se logra con constancia, no con acciones aisladas.
                        <br /><br />
                        5. <b>Conversa con tu equipo:</b> Comparte aprendizajes, escucha preocupaciones y construyan juntos soluciones.
                        <br /><br />
                        Cada mejora que implementes puede evitar un incidente.
                        <br />
                        Cada intervención oportuna puede marcar la diferencia.
                        <br /><br />
                        Al final, el verdadero éxito no es solo cumplir metas operativas, sino lograr que todas las personas regresen a casa sanas y seguras al terminar la jornada.
                        <br /><br />
                        <Text style={{ color: '#339C98', fontWeight: 600 }}>
                            ¡Confiamos en tu liderazgo y en tu capacidad para convertir estos resultados en acciones concretas!
                        </Text>
                        <br /><br />
                        <Text style={{ color: '#339C98', fontWeight: 600 }}>
                            Equipo {orgName || 'Organización'}
                        </Text>
                    </div>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageWelcome2Selfcare360;
